import React from "react";

import { testLocator } from "@/lib/helpers/test-locator";

import { MAX_CHAT_LENGTH_MESSAGE } from "./constants";

const URL_REGEX = /((?:https?:\/\/|www\.)[^\s]+)/gi;
const WWW_PREFIX_TEST = /^www\./i;
const URL_PREFIX_TEST = /^(?:https?:\/\/|www\.)/i;

const Message = (props) => {
  let { message } = props;

  const renderLinks = React.useCallback((message) => {
    const parts = message.split(URL_REGEX);

    return parts.map((part, index) => {
      if (URL_PREFIX_TEST.test(part)) {
        const href = WWW_PREFIX_TEST.test(part) ? `//${part}` : part;

        return (
          <a href={href} key={index} rel="noreferrer" target="_blank">
            {part}
          </a>
        );
      }

      return <React.Fragment key={index}>{part}</React.Fragment>;
    });
  }, []);

  const readMessage = (message) => {
    let contentToRender = message;

    if (message.length > MAX_CHAT_LENGTH_MESSAGE) {
      contentToRender = message.slice(0, MAX_CHAT_LENGTH_MESSAGE) + "... (message truncated)";
    }

    const lines = contentToRender.split("\n");

    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {renderLinks(line)}
        {index !== lines.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div className="tw:wrap-break-word" {...testLocator("chatMessage")}>
      {readMessage(message)}
    </div>
  );
};

export default React.memo(Message);
